import React, { useMemo } from 'react';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import { RapportPdvDTO } from '../../utils/types/objects/RapportPdvDTO';

interface LivraisonCartePdvChartProps {
    data: RapportPdvDTO[] | undefined;
    isLoading: boolean;
}

export const LivraisonCartePdvChart: React.FC<LivraisonCartePdvChartProps> = ({ data, isLoading }) => {
    const chartData = useMemo(() => {
        if (!data) return { categories: [], countSeries: [] };

        return {
            categories: data.map((d) => d.nomPdv || 'Station inconnue'),
            countSeries: data.map((d) => d.nbLivraisonCarte || 0),
        };
    }, [data]);

    const options: ApexOptions = {
        chart: {
            id: 'livraisons-pdv-chart',
            toolbar: { show: true },
            zoom: { enabled: false },
            fontFamily: 'inherit',
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                horizontal: false,
                columnWidth: '55%',
                dataLabels: {
                    position: 'top',
                },
            },
        },
        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return val.toString();
            },
            offsetY: -20,
            style: {
                fontSize: '12px',
                colors: ['#304758'],
            },
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent'],
        },
        xaxis: {
            categories: chartData.categories,
            labels: {
                style: { fontSize: '12px' },
                trim: true,
            },
        },
        yaxis: {
            title: { text: 'Nombre de livraisons' },
        },
        fill: {
            opacity: 1,
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + ' livraisons';
                },
            },
        },
        colors: ['#008FFB', '#00E396'],
        legend: {
            position: 'top',
        },
    };

    const series = [
        {
            name: 'Nb Livraisons',
            data: chartData.countSeries,
        },
    ];

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '350px' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Chargement...</span>
                </div>
            </div>
        );
    }

    if (!data || data.length === 0) {
        return (
            <div className="text-center p-4 text-muted" style={{ height: '350px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <p>Aucune donnée de livraison disponible pour cette période.</p>
            </div>
        );
    }

    return (
        <div className="card shadow-sm">
            <div className="card-body">
                <Chart options={options} series={series} type="bar" height={350} width="100%" />
            </div>
        </div>
    );
};
